import React from 'react';
import { useDialogStore } from '../../store/dialogStore';
import { useGlobalStore } from '../../store/globalStore';
import { Button } from '../ui/button';
import { ChevronRightIcon, XMarkIcon } from '@heroicons/react/24/outline';

const DialogLayout: React.FC = () => {
  const isLoading = useGlobalStore((state) => state.isLoading);

  const {
    isOpen,
    disableFooter,
    content,
    closeButtonLabel,
    saveButtonLabel,
    closeDialog,
    onSave,
    mousePositionWithScroll,
  } = useDialogStore();

  if (!isOpen) return null;

  const handleOutsideClick = (e: React.MouseEvent) => {
    if ((e.target as HTMLElement).id === 'dialog-overlay') {
      closeDialog();
    }
  };

  return (
    <div
      id="dialog-overlay"
      className="animate__animated animate__fadeIn animate__faster fixed flex items-start justify-center left-0 right-0 top-0 bottom-0 z-50 w-full h-full backdrop-blur-sm"
      onClick={handleOutsideClick}
    >
      <div
        id="dialog"
        style={{
          ...(mousePositionWithScroll !== 0 && {
            top: mousePositionWithScroll - 180 + 'px',
          }),
        }}
        className={`animate__animated animate__zoomIn animate__faster mx-4 relative shadow-xl border-gray-600 rounded-md container max-w-lg bg-white border-2 ${mousePositionWithScroll === 0 ? 'mt-36' : ''
          }`}
        onClick={(e) => e.stopPropagation()}
      >
        {disableFooter && (
          <div
            onClick={closeDialog}
            className="absolute cursor-pointer font-medium z-10 right-2 top-2 bg-gray-500 hover:bg-gray-700 text-white px-2 py-1 rounded-sm"
          >
            OK
          </div>
        )}

        <div className={`p-3 ${disableFooter ? 'mx-16' : ''}`}>{content}</div>
        {!disableFooter && (
          <div className="flex p-3 bg-gray-100 rounded-b-md items-center justify-between border-t">
            <Button
              className="bg-red-200 border border-red-300 hover:bg-red-300 text-red-600"
              onClick={closeDialog}
              disabled={isLoading}
            >
              <XMarkIcon />
              {closeButtonLabel}
            </Button>
            <Button disabled={isLoading} className="px-10" onClick={onSave}>
              <span className="font-bold">
                {isLoading ? 'Laden ...' : saveButtonLabel}
              </span>
              <ChevronRightIcon />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DialogLayout;
